export function toHttps(url) {
  return url.replace('http://', 'https://');
}

// 获取url里面的参数
export function getUrlQuery(param){
  const url = window.location.search.substr(1);
  const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)');
  const res = url.match(reg);
  if (res) {
      return decodeURI(res[2]);
  }
  return undefined;
}

// 从url里面获取query的值
export function getQueryFromUrl(query, url) {
  const regExp = new RegExp('(\\?|&)' + query + '=([^&]*)(&|$)');
  const res = url.match(regExp);
  if (res) {
      return decodeURI(res[2]);
  }
  return undefined;
}


export function supportLocalStorage () {
	var test = 'test';
	try {
		localStorage.setItem(test, test);
		localStorage.removeItem(test);
		return true;
	} catch (e) {
		return false;
	}
}

export function supportSessionStorage () {
	var test = 'test';
	try {
		sessionStorage.setItem(test, test);
		sessionStorage.removeItem(test);
		return true;
	} catch (e) {
		return false;
	}
}
export function setLocalStorage (key, value) {
	if (supportLocalStorage) {
		localStorage.setItem(key, value);
	}else if(supportSessionStorage){
		sessionStorage.setItem(key, value);
	}
}
export function getLocalStorage (key) {
	if (supportLocalStorage) {
		return localStorage.getItem(key);
	}else if(supportSessionStorage){
		return sessionStorage.getItem(key);
	}
}
export function removeLocalStorage (key) {
	if (supportLocalStorage) {
		return localStorage.removeItem(key);
	}else if(supportSessionStorage){
		return sessionStorage.removeItem(key);
	}
}

function numDigitTwo(num) {
	let number = '' + num;

	return number.length > 1 ? number : '0'+ number;
}

export function secondsToTime (seconds) {
	if(seconds === 0) {
		return '00:00:00';
	}
	let _seconds = seconds;
	let hours = Math.floor(_seconds/(60*60));
	_seconds -= hours*60*60;
	let mins = Math.floor(_seconds/60)
	_seconds -= mins*60;

	return numDigitTwo(hours) + ':' + numDigitTwo(mins) + ':' + numDigitTwo(_seconds);
}

//页面不挪动
export function pageNotMove(notMove) {
	if(notMove) {
		document.getElementsByTagName('body')[0].classList.add("notmove");
		document.getElementsByTagName('html')[0].classList.add("notmove");
	}else {
		document.getElementsByTagName('body')[0].classList.remove("notmove");
		document.getElementsByTagName('html')[0].classList.remove("notmove");
	}
}

// 判断是大字版or普通版
function getAppType() {
    const ua = window.navigator.userAgent,
          isPlus = /qnreadingplus/.test(ua.toLowerCase()),
          isFocus = /qnreadingfocus/.test(ua.toLowerCase())
          
    return isPlus ? 'plus' : isFocus ? 'focus' : 'normal'
}

export function getSchemeHeader() {
    const appType = getAppType()
    return appType === 'plus' ? 'qnreadingplus' : appType === 'focus' ? 'qnreadingfocus' :'qnreading'
}

//名字打点
export function getDimame(name) {
    if(!name.length || name.length === 1) {
		return name;
	}

	const len = name.length;
	if(len === 2) {
		return name[0] + '*';
	}else {
		let dim = name.substr(0, 1);
		let count = 0;
		for(let i = 1 ; i < len-1 ; i ++) {
			if(count >= 3){
				break;
			}
			dim += '*';
			count ++;
		}
		dim += name.substr(len-1, 1);

		return dim;
	}
}

export function getRandom(max) {
	return parseInt(Math.random()*(max+1),10);
}

export function loadScript(url) {
	return new Promise((resolve, reject) => {
		// 检查本地的script是否已经有了
		const $scripts = document.scripts
		for (let index = 0; index < $scripts.length; index++) {
			const $script = $scripts[index]
			const scriptSrc = $script.getAttribute('src') || ''
			if (scriptSrc.includes(url)) return resolve()
		}

		const script = document.createElement('script')
		script.src = url
		script.async = true
		script.onload = resolve
		script.onreadystatechange = function() {
			if (this.readyState === 'complete') {
				resolve()
			}
		};
		document.getElementsByTagName('head')[0].appendChild(script);
	})
}